(() => {
  "use strict";

  var e,
    n = {
      d: (e, t) => {
        for (var a in t) n.o(t, a) && !n.o(e, a) && Object.defineProperty(e, a, {
          enumerable: !0,
          get: t[a]
        });
      },
      o: (e, n) => Object.prototype.hasOwnProperty.call(e, n),
      r: e => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
    t = {};
  n.r(t), n.d(t, {
    GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA: () => o,
    default: () => l,
    fetchFromGraphQL: () => r,
    fetchMediaData: () => i,
    fetchRecommendedItems: () => d,
    getVersion: () => s,
    transformMediaItemToMediaData: () => a
  }), function (e) {
    e.DEV = "dev", e.QA = "qa", e.PROD = "prod", e.STG = "stg";
  }(e || (e = {}));
  const a = e => {
      var n, t, a, o, r, i, d, s, l, m, c;
      if (!(null == e ? void 0 : e.media)) return null;
      const u = {};
      return u.sourceId = e.sourceId, u.mediaId = e.mediaId, u.mediaNetId = null !== (t = null === (n = e.media.id) || void 0 === n ? void 0 : n.toString()) && void 0 !== t ? t : null, u.callSign = e.media.callSign, u.source = e.source, u.format = e.type, u.assets = e.media.assets || null, u.adOrder = e.media.adOrder, u.adCategoryExclusion = e.media.adCategoryExclusion, u.isLive = "Live" === e.media.streamType, u.contentArea = e.media.contentArea, u.contentTier = null !== (o = null === (a = e.media.contentTierId) || void 0 === a ? void 0 : a.toString()) && void 0 !== o ? o : null, u.tags = e.tags || [], u.concepts = e.concepts || [], u.duration = e.media.duration, u.showName = null !== (i = null === (r = e.showData) || void 0 === r ? void 0 : r.name) && void 0 !== i ? i : e.showName, u.title = e.title, u.thumbnail = (e => {
        var n, t;
        let a = null == e ? void 0 : e.url;
        const o = null === (t = null === (n = null == e ? void 0 : e.aspects) || void 0 === n ? void 0 : n.ratio16x9) || void 0 === t ? void 0 : t.url;
        return o && (a = `${o}Resize%3D1180`), a;
      })(e.image), u.genre = e.media.genre, u.type = e.media.clipType, u.brandedSponsorName = e.media.brandedSponsorName, u.season = null !== (s = null === (d = e.media.season) || void 0 === d ? void 0 : d.toString()) && void 0 !== s ? s : null, u.episode = null !== (m = null === (l = e.media.episode) || void 0 === l ? void 0 : l.toString()) && void 0 !== m ? m : null, u.region = e.media.region, u.pubDate = parseInt(e.publishedAt), u.sport = null === (c = e.media.sports) || void 0 === c ? void 0 : c.name, u.hasCaptions = e.media.hasCaptions, u.aspectRatio = e.media.aspectRatio, u.shareUrl = `https://www.cbc.ca/player/play/${e.type}/${e.sourceId}`, e.media.chapters && (u.chapters = e.media.chapters), e.media.textTracks && (u.textTracks = e.media.textTracks.map(e => ({
        label: e.label,
        srclang: e.language,
        src: e.src,
        kind: e.kind
      }))), u;
    },
    o = "\n    sourceId\n    mediaId\n    source\n    title\n    image {\n        url\n        aspects {\n            ratio16x9 {\n                url\n            }\n        }\n    }\n    publishedAt\n    type\n    showData {\n        name\n    }\n    showName\n    tags {\n        type\n        name\n    }\n    concepts {\n        type\n        path\n    }\n    media {\n        id\n        callSign\n        assets {\n            key\n            type\n            options {\n                token\n            }\n        }\n        adOrder\n        adCategoryExclusion\n        streamType\n        contentArea\n        contentTierId\n        duration\n        genre\n        clipType\n        brandedSponsorName\n        season\n        episode\n        region\n        sports {\n            name\n        }\n        hasCaptions\n        aspectRatio\n        textTracks {\n            kind\n            label\n            src\n            language\n        }\n        chapters {\n            name\n            startTime\n        }\n    }\n",
    r = async (n, t) => {
      const a = (n => {
          let t = ".";
          return n !== e.DEV && n !== e.QA || (t = `.${n}.nm.`), `https://www${t}cbc.ca/${n === e.STG ? "gql-stg" : "graphql"}`;
        })(t),
        o = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Cache-By-Country": "true"
          },
          body: JSON.stringify(n)
        },
        r = await fetch(a, o);
      return await r.json();
    },
    i = async (e, n, t) => {
      var i;
      if (!e) return null;
      let d = null;
      const s = ((e, n) => ({
        query: `{ contentItem(${e.toString().includes(".") ? `sourceId: "${e}"` : `mediaId: ${e}`}${n ? `, token: "${n}", workflowState: ALL` : ""}) {\n            ${o}\n        }}`
      }))(e, t);
      try {
        const e = null === (i = (await r(s, n)).data) || void 0 === i ? void 0 : i.contentItem;
        if (!e) throw new Error("No GQL media item in GraphQL response");
        d = a(e);
      } catch (e) {
        return console.error(e), d;
      }
      return d;
    },
    d = async (e, n, t, i, d) => {
      var s, l, m, c;
      if (!e) throw new Error("Missing mandatory argument 'algorithmId'.");
      const u = Number.isInteger(t) ? t : 2,
        p = null == i || i,
        v = {
          query: ""
        };
      if (n) v.query = `{\n            personalizedItems(algorithmId: "${e}", userId: "${n}", allowPersonalized: ${p}, first: ${u}) {\n                nodes {\n                    ${o}\n                }\n                algorithmId\n            }\n        }`;else {
        const n = "rec4you-short-form-news-video" === e ? "short-form-news-video" : "short-form-video";
        v.query = `{\n            mlDrivenItems(algorithm: "trending", type: "video", pageSize: ${u}, args: { trendingType: "${n}", allowPersonalized: ${i}} }) {\n                items {\n                    ${o}\n                }\n            }\n        }`;
      }
      let h = [];
      try {
        const e = await r(v, d),
          t = n ? null === (l = null === (s = null == e ? void 0 : e.data) || void 0 === s ? void 0 : s.personalizedItems) || void 0 === l ? void 0 : l.nodes : null === (c = null === (m = null == e ? void 0 : e.data) || void 0 === m ? void 0 : m.mlDrivenItems) || void 0 === c ? void 0 : c.items;
        (null == t ? void 0 : t.length) && (h = t.filter(e => {
          var n, t;
          return null === (t = null === (n = null == e ? void 0 : e.media) || void 0 === n ? void 0 : n.assets) || void 0 === t ? void 0 : t.length;
        }).map(e => a(e)));
      } catch (e) {
        console.error(e);
      }
      return h;
    },
    s = () => "1.8.1",
    l = {
      fetchMediaData: i,
      fetchRecommendedItems: d,
      fetchFromGraphQL: r,
      getVersion: s,
      transformMediaItemToMediaData: a,
      GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA: o
    };
  exports.GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA = t.GQL_CONTENTITEM_FRAGMENT_FOR_MEDIA, exports.default = t.default, exports.fetchFromGraphQL = t.fetchFromGraphQL, exports.fetchMediaData = t.fetchMediaData, exports.fetchRecommendedItems = t.fetchRecommendedItems, exports.getVersion = t.getVersion, exports.transformMediaItemToMediaData = t.transformMediaItemToMediaData, Object.defineProperty(exports, "__esModule", {
    value: !0
  });
})();